import { api } from "./api";

export interface ThemeViewFile {
  name: string;
  size: number;
  updated_at: string;
}

export interface ThemeViewFileListResponse {
  success: boolean;
  files: ThemeViewFile[];
  message?: string;
}

export interface ThemeViewFileGetResponse {
  success: boolean;
  file: string;
  content: string;
  updated_at: string;
  message?: string;
}

export interface ThemeViewFileSaveResponse {
  success: boolean;
  message: string;
  file: string;
  bytes_written: number;
  updated_at: string;
}

export async function listThemeViewFiles(): Promise<ThemeViewFileListResponse> {
  return api.get<ThemeViewFileListResponse>("/theme-files.php?action=list");
}

export async function getThemeViewFile(
  fileName: string,
): Promise<ThemeViewFileGetResponse> {
  return api.get<ThemeViewFileGetResponse>(
    `/theme-files.php?action=get&file=${encodeURIComponent(fileName)}`,
  );
}

export async function saveThemeViewFile(
  fileName: string,
  content: string,
): Promise<ThemeViewFileSaveResponse> {
  return api.put<ThemeViewFileSaveResponse>("/theme-files.php?action=save", {
    file: fileName,
    content,
  });
}
